const baseUrl = "https://progitek.no/privat/bp/"
const mediaEndpoint = "wp-json/wp/v2/media"
const footballBlogEndpoint = "wp-json/wp/v2/football_blog"
const wonderKidsEndpoint = "wp-json/wp/v2/vidunderbarn"

export async function getWpMedia(baseUrl = "https://progitek.no/privat/bp/", perPage = 9, page = 1) {
    let data = []
    try {
        const response = await fetch(baseUrl + mediaEndpoint + "?per_page=" + perPage + "&page=" + page)
        data = await response.json()
    } catch (error) {
        
    }
    return data
}

export async function getWpFootballPosts(page=1, perPage=10) {
    let data = []
    try {
        const response = await fetch(`${baseUrl}${footballBlogEndpoint}?per_page=${perPage}&page=${page}`);
        data = await response.json()
    } catch (error) {
        
    }
    return data
}
export async function getSingleWpFootballPost(id) {
    let data = []
    try {
        const response = await fetch(`${baseUrl}${footballBlogEndpoint}/${id}`);
        data = await response.json()
    } catch (error) {

    }
    return data
}

export async function getWpWonderKids(page=1, perPage=100) {
    let data = []
    try {
        const response = await fetch(`${baseUrl}${wonderKidsEndpoint}?per_page=${perPage}&page=${page}`);
        data = await response.json();
    } catch (error) {
        
    }
    return data;
}